import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class BoardMediaSliderFormBase extends FormBase {
    public getPostDetailPreviewRoot(root: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, ".post-detail-media-preview", HTMLElement);
    }

    public getPostDetailContentWrapper(root: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, ".post-detail-media-preview__content-wrapper", HTMLElement);
    }

    public getTrack(root: ParentNode): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.SNS_PREVIEW_TILES_GRID}"], [data-role="${Roles.BOARD_IMAGES_GRID}"]`,
            HTMLElement,
        );
    }

    public getMediaAreas(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.BOARD_MEDIA_AREA}"]`, HTMLElement);
    }

    public getGrid(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BOARD_IMAGES_GRID}"]`, HTMLElement);
    }

    public getNavButton(root: ParentNode, direction: "prev" | "next"): HTMLButtonElement | null {
        return this.queryElement(root, `.board-media-slider__nav--${direction}`, HTMLButtonElement);
    }

    public getDotsContainer(root: ParentNode): HTMLElement | null {
        const local = this.queryElement(root, `[data-role="${Roles.HORIZONTAL_SLIDER_DOTS}"]`, HTMLElement);
        if (local instanceof HTMLElement) {
            return local;
        }

        const previewRoot = this.getPostDetailPreviewRoot(root);
        if (previewRoot instanceof HTMLElement) {
            return this.queryElement(previewRoot, `[data-role="${Roles.HORIZONTAL_SLIDER_DOTS}"]`, HTMLElement);
        }

        return null;
    }

    public getDots(root: ParentNode): HTMLButtonElement[] {
        return this.queryElements(root, `[data-role="${Roles.HORIZONTAL_SLIDER_DOT}"]`, HTMLButtonElement);
    }

    public getSlideItems(root: ParentNode): HTMLElement[] {
        return this.queryElements(
            root,
            `:scope > .board-image-item, :scope > .board-video-wrap, :scope > [data-role="${Roles.SNS_PREVIEW_TILE}"], :scope > [data-role="${Roles.OGP_PREVIEW_CARD}"], :scope > [data-role="${Roles.YOUTUBE_PREVIEW}"], :scope > [data-role="${Roles.FACEBOOK_PREVIEW}"]`,
            HTMLElement,
        );
    }

    public getDirectSlides(root: ParentNode): HTMLElement[] {
        return this.queryElements(
            root,
            `:scope > .board-image, :scope > .board-video-wrap, :scope > [data-role="${Roles.OGP_PREVIEW_CARD}"], :scope > [data-role="${Roles.YOUTUBE_PREVIEW}"], :scope > [data-role="${Roles.FACEBOOK_PREVIEW}"], :scope > [data-role="${Roles.SNS_PREVIEW_TILE}"]`,
            HTMLElement,
        );
    }

    public getImages(root: ParentNode): HTMLImageElement[] {
        return this.queryElements(root, ".board-image", HTMLImageElement);
    }
}

const boardMediaSliderForm = new BoardMediaSliderFormBase();

export { boardMediaSliderForm };
